import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';

const initialState = {
  mobileDrawerOpen: false,
};

const reducers = {
  setMobileDrawerOpen(state, { payload }) {
    return R.assoc('mobileDrawerOpen', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'mobileDrawer',
  reducers,
});

export const getMobileDrawerOpen = R.path([
  'loadingManagement',
  'mobileDrawer',
  'mobileDrawerOpen',
]);

export const { setMobileDrawerOpen } = actions;

export default reducer;
